import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./context/LanguageContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ChatWidget from "./components/ChatWidget";
import { BrowserBranding } from "./components/BrowserBranding";
import Home from "./pages/Home";
import HowItWorks from "./pages/HowItWorks";
import Marketing from "./pages/Marketing";
import Pricing from "./pages/Pricing";
import BookDemo from "./pages/BookDemo";
import FAQPage from "./pages/FAQPage";
import Admin from "./pages/Admin";
import { Privacy, Terms } from "./pages/Legal";

function App() {
  return (
    <div className="App min-h-screen bg-white">
      <BrowserBranding />
      <LanguageProvider>
        <BrowserRouter>
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/marketing" element={<Marketing />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/book-demo" element={<BookDemo />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
            </Routes>
          </main>
          <Footer />
          <ChatWidget />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
